const baseDefaultOptions: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: '2-digit',
  day: '2-digit',
}

export const shortYearFormattingOptions: Intl.DateTimeFormatOptions = {
  ...baseDefaultOptions,
  year: '2-digit',
}

export const fullYearFormattingOptions: Intl.DateTimeFormatOptions = {
  ...baseDefaultOptions,
  year: 'numeric',
}

export const shortMonthInformal: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
}

export const shortMonthInformalFullYear: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
}

type FormattingOptions = {
  year?: 'short' | 'full'
  defaultValue?: string
  options?: Intl.DateTimeFormatOptions
}

export const formatDate = (
  date?: string,
  formattingOptions: FormattingOptions = { options: shortYearFormattingOptions },
) => {
  if (!date) return formattingOptions?.defaultValue || ''

  const dateObj = new Date(date)
  const options =
    formattingOptions.options ??
    (formattingOptions.year === 'full' ? fullYearFormattingOptions : shortYearFormattingOptions)

  return dateObj.toLocaleDateString('en-GB', options)
}
